export default __webpack_public_path__ + "static/media/jio_payment_bank.1dc583b9.png";